import { lazy } from 'react';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

const ContractSigningPage = Loadable(lazy(() => import('pages/client-link')));

// ==============================|| PUBLIC ROUTES (NO AUTH) ||============================== //

const PublicRoutes = {
  path: '/sign',
  element: <CommonLayout />,
  children: [
    {
      path: '/sign/:token',
      element: <ContractSigningPage />
    }
  ]
};

export default PublicRoutes;
